const WAC_PREFIX = 'wac-';
const prefixToken = (token) => {
    if (!token) {
        return '';
    }
    const isImportant = token.startsWith('!');
    const cleanToken = isImportant ? token.slice(1) : token;
    const segments = cleanToken.split(':');
    const lastIndex = segments.length - 1;
    const prefixedSegments = segments.map((segment, index) => {
        if (!segment) {
            return segment;
        }
        if (index === lastIndex) {
            return segment.startsWith(WAC_PREFIX) ? segment : `${WAC_PREFIX}${segment}`;
        }
        return segment;
    });
    const prefixed = prefixedSegments.join(':');
    return isImportant ? `!${prefixed}` : prefixed;
};
const normalizeInput = (input) => input
    ? input
        .trim()
        .split(/\s+/)
        .map(prefixToken)
        .join(' ')
    : '';
/**
 * Prefix Tailwind utility classes with the required `wac-` namespace.
 * Accepts any number of class string segments (falsy values are ignored).
 */
export const wac = (...classLists) => {
    return classLists.filter(Boolean).map((item) => normalizeInput(item)).join(' ');
};
export default wac;
